export default __webpack_public_path__ + "static/media/jest-tutorial.1fdd4451.png";